import { COLORS, FONTS } from '../styles/tokens';
import type { ColorTheme } from '../styles/tokens';
import { OrgTreeView } from './OrgTreeView';
import type { OrgTreeNode } from '../api/keycloak-admin/org-config';

interface OrgTreeColumnProps {
  units: OrgTreeNode[];
  selectedNodeId: string | null;
  isDark: boolean;
  colors: ColorTheme;
  onSelect: (id: string) => void;
  onAddChild: (id: string) => void;
  onDelete: (id: string) => void;
  onAddRoot: () => void;
}

/** Left column: org tree display with add/select/delete controls */
export function OrgTreeColumn({
  units, selectedNodeId, isDark, colors, onSelect, onAddChild, onDelete, onAddRoot,
}: OrgTreeColumnProps): React.JSX.Element {
  return (
    <div className="vx-fill-col" style={{
      flex: '1 1 400px', minWidth: '300px',
      border: `1px solid ${colors.border}`, borderRadius: '10px',
      padding: '12px', overflow: 'auto', maxHeight: '600px',
      backgroundColor: isDark ? COLORS.dark.card : COLORS.light.card,
    }}>
      {units.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <p style={{ fontFamily: FONTS.body, fontSize: '13px', color: colors.textSecondary, marginBottom: '12px' }}>
            No org tree. Apply a template or add a root unit.
          </p>
          <button onClick={onAddRoot} style={{
            padding: '8px 16px', borderRadius: '6px',
            border: `1px solid ${colors.border}`, backgroundColor: 'transparent',
            color: colors.text, fontFamily: FONTS.body, fontSize: '12px', cursor: 'pointer',
          }}>+ Add Root Unit</button>
        </div>
      ) : (
        <>
          <OrgTreeView nodes={units} selectedId={selectedNodeId}
            onSelect={onSelect} onAddChild={onAddChild} onDelete={onDelete} />
          <button onClick={onAddRoot} style={{
            marginTop: '8px', padding: '6px 12px', borderRadius: '6px', border: 'none',
            backgroundColor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.04)',
            color: isDark ? '#888' : '#666', fontFamily: FONTS.body, fontSize: '11px',
            cursor: 'pointer', width: '100%',
          }}>+ Add Root Unit</button>
        </>
      )}
    </div>
  );
}
